import { useLazyQuery as l } from "@apollo/client";
import { publicAccountSchema as m } from "../../deserialize/yup/account.js";
import { deserializeListData as d } from "../../graphql/deserialize/index.js";
import p from "../../graphql/query/getPublicAccountDetail.js";
import * as f from "ramda";
import { useState as P, useCallback as A } from "react";
const L = () => {
  const [t, { loading: r }] = l(p), [c, e] = P(null);
  return {
    fetch: A(
      async (n) => {
        const { accountId: a, walletAddress: s } = n, u = await t({
          variables: { input: { ...a ? { accountID: [a] } : {}, ...s ? { walletAddress: [s] } : {} } }
        }), i = d(
          u,
          m
        ), o = f.propOr(null, "0", i);
        return e(o), o;
      },
      [t]
    ),
    data: c,
    loading: r
  };
};
export {
  L as default
};
//# sourceMappingURL=useGetPublicAccountDetail.js.map
